<div *ngIf="constructor.name.length > 1" class="component-name">>> {{constructor.name}} <<</div>

<div appTheme>
    <form (ngSubmit)="onForgotPassword(f)" #f="ngForm">
        <div class="modal-box scrolling">
            <div class="col-sm-6 main-container">
                <div class="col-sm-12">
                    <h1>Reset Password</h1>
                    <p>Enter your email address to receive instructions on how to reset your password.</p><br>
                    <p class="error-message">{{errorMessage}}<br></p>
                    <input
                        class="input-text"
                        type="email"
                        name="email"
                        [ngModel]="email"
                        placeholder="Email"
                        email
                        required
                        maxlength="50"
                        #emailRef="ngModel"
                        pattern="[A-Z0-9a-z._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}"
                    />
                    <span class="help-block" *ngIf="!emailRef.valid && emailRef.touched">Please enter a valid email address.</span>
                    <div class="bottom">
                        <button class="submit-button button-medium" id="submitBtn" [disabled]="f.invalid">
                            Submit <i class="fa fa-arrow-right" aria-hidden="true"></i>
                        </button>
                        <button class="cancel-button button-small" id="cancelBtn" (click)="goToMain()">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-box scrolling" *ngIf="showEmailConfirmation">
        <div class="modal-box-container-result main-container">
            <p>A password reset email has been sent to {{email}}.</p>
            <p>Follow the instructions in the email to reset your password.</p>
            <div class="bottom">
                <button class="submit-button button-small" id="okBtn" (click)="goToMain()">Ok</button>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isLoading" class="modal-box scrolling">
    <app-loading [text]="'Sending request to reset password...'" [size]="'fa-5x'"></app-loading>
</div>
